import DeliveryAddressNewPage from '../../../components/pages/gift_card_tickets/delivery_addresses/DeliveryAddressNewPage.vue'

export default {
  components: { DeliveryAddressNewPage }
}
